
import { Typography } from '@material-tailwind/react'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { useParams } from 'react-router-dom'
import { useBalancesViewQuery } from '../../store/auth/authService'
import { setContractId, setServiceId } from '../../store/service/contractSlice'
import { AppDispatch } from '../../store/store'
import { isIterableArray, replacedString } from '../../utils/utils'
import TableSortingCreator from '../tableHelpers/TableSortingCreator'
import PageLayout from '../../layouts/pagesLayouts/PageLayout'
import OverlayUnTouchable from '../../layouts/pagesLayouts/OverlayUnTouchable'
import TableLayout from '../../layouts/pagesLayouts/TableLayout'
import { Helmet } from 'react-helmet'
import BalancesFilters from './BalancesFilters'
import { BalancesFilterFormType, BalancesRowType } from './BalancesPage.types'
import BalancesTableDumb from './BalancesTableDumb'
import axios from 'axios'
import { baseApi } from '../../ConfigApi'
import { errorToast } from '../../components/toasts/toasts'
import fileDownload from 'js-file-download'
import useRolePage from '../../utils/useRolePage'
import ErrorCatchLayout from '../../layouts/pagesLayouts/ErrorCatchLayout'


const BalancesPage = () => {

    const { data: roles } = useRolePage();

    const { param_contract_id } = useParams()
    const { t } = useTranslation()

    const form: BalancesFilterFormType = {
        contract_id: param_contract_id,
        periodFrom: '',
        periodTo: '',
        balances: [],
    }

    const [sendForm, setSendForm] = useState<BalancesFilterFormType>(form);
    const dispatch = useDispatch<AppDispatch>()


    const { currentData, error, isLoading, isFetching, refetch } = useBalancesViewQuery(sendForm)


    // array all rows
    const [rows, setRows] = useState<BalancesRowType[]>([]);

    const [tableRows, setTableRows] = useState<BalancesRowType[]>([]);
    const [search, setSearch] = useState<string>('');

    const [isLoadingTable, setIsLoadingTable] = useState<boolean>(true);

    useEffect(() => {
        dispatch(setContractId(Number(param_contract_id)))
    }, [param_contract_id]);

    useEffect(() => {
        if (currentData?.service_id) dispatch(setServiceId(Number(currentData.service_id)))
    }, [currentData]);

    const setFormForFetch = (values: any) => {
        setIsLoadingTable(true)
        setTableRows([])
        setSendForm(prev => ({
            ...prev, ...{
                ...values,
                contract_id: param_contract_id
            }
        }))
    }

    useEffect(() => {
        if (
            !isLoading && !isFetching && isIterableArray(tableRows) ||
            !isLoading && !isFetching && Array.isArray(currentData?.rows) && !isIterableArray(currentData?.rows)
        ) {
            setIsLoadingTable(false)
        }
    }, [isLoading, isFetching, tableRows, currentData?.rows]);


    // ______CREATE_DATA
    useEffect(() => {
        if (isIterableArray(currentData?.rows)) {
            const res: BalancesRowType[] = currentData.rows.map((item: BalancesRowType) => createData(item))
            setRows(res)
        }
        else setRows([])
    }, [currentData]);

    useEffect(() => {
        onSearch(search)
    }, [rows]);

    const onSearch = (searchValue: string) => {
        setSearch(searchValue);
        const reg = new RegExp(replacedString(searchValue), "gi");
        if (searchValue === "") {
            setTableRows(rows)
            return
        }
        if (isIterableArray(rows)) {
            const filteredData: BalancesRowType[] = rows.filter((item: any) => {
                const keys = Object.keys(item);
                let matches = 0;
                keys.forEach((key) => {
                    const val = replacedString(String(item[key]))
                    if (reg.test(val)) matches++;
                });
                return matches > 0;
            });
            if (searchValue !== "" && filteredData.length > 0) {
                setTableRows(filteredData);
            }
            if (searchValue !== "" && filteredData.length === 0) {
                setTableRows([]);
            }
        }


    };


    function createData(data: BalancesRowType) {
        return {
            key: data.key,
            balance_start: data.balance_start,
            amount_act: data.amount_act,
            amount_act_nds: data.amount_act_nds,
            amount_delta: data.amount_delta,
            amount_delta_nds: data.amount_delta_nds,
            payment: data.payment,
            payment_nds: data.payment_nds,
            transfer: data.transfer,
            transfer_nds: data.transfer_nds,
            count_act: data.count_act,
            count_delta: data.count_delta,
            credit_start: data.credit_start,
            credit_nds_start: data.credit_nds_start,
            debet_start: data.debet_start,
            debet_nds_start: data.debet_nds_start,
            balance_end: data.balance_end,
            credit_end: data.credit_end,
            credit_nds_end: data.credit_nds_end,
            debet_end: data.debet_end,
            debet_nds_end: data.debet_nds_end,
            balance_id: t(`balance_${data.balance_id}`),
            period: data.period,
            period_sorter: data.period_sorter,
            month: data.month,
            year: data.year
        };
    }

    const downloadExcel = (_: any, callback: any) => {

        const form = {
            periodFrom: sendForm.periodFrom,
            periodTo: sendForm.periodTo,
            contract_id: sendForm.contract_id,
            balances: sendForm.balances,
        }
        axios.post(`${baseApi}/api/ca/view-balance-period-excel`, form)
            .then((response: any) => {
                if (response.data.res === 'error') {
                    errorToast({
                        title: t('balances_page.balances_title'),
                        text: t('error_on_download')
                    })
                    if (callback) callback()
                }
                else {
                    setTimeout(() => {
                        axios.post(`${baseApi}/api/ca/view-balance-period-excel/export-file`, {
                            contract_id: sendForm.contract_id,
                            filename: response.data.nameFile
                        }, { responseType: 'blob', })
                            .then((response: any) => {
                                if (response.data.res === 'error') {
                                    errorToast({
                                        title: t('balances_page.balances_title'),
                                        text: t('error_on_download')
                                    })
                                }
                                else {
                                    fileDownload(response.data, `${t('balances_page.balances_title')}.xlsx`)
                                }
                            })
                            .catch(error => {
                                console.error(error);
                                errorToast({
                                    title: t('balances_page.balances_title'),
                                    text: t('error_on_download')
                                })
                            })
                            .finally(() => {
                                if (callback) callback()
                            })
                    }, 5000);

                }
            })
            .catch(error => {
                console.error(error);
                errorToast({
                    title: t('balances_page.balances_title'),
                    text: t('error_on_download')
                })
                if (callback) callback()
            })
            .finally(() => {
                if (callback) callback()
            })
    }

    return (
        <PageLayout title={
            <Typography variant='h3' className='text-gray-800 text-center mb-[64px]'>
                {t('balances_page.balances_title')}
            </Typography>
        }>
            <Helmet>
                <title>
                    {t('balances_page.balances_title')}
                </title>
            </Helmet>
            <OverlayUnTouchable isOverlay={false} errorForbidden={error}>
                <BalancesFilters
                    roles={roles}
                    isLoadingFetch={isFetching}
                    fetchPage={setFormForFetch}
                    onSearch={onSearch}
                    downloadExcel={downloadExcel}
                    disabledDownload={!isIterableArray(tableRows)}
                />
            </OverlayUnTouchable>
            <OverlayUnTouchable isOverlay={(isFetching || isLoading || !!error)}>
                {
                    error ?
                        <ErrorCatchLayout error={error} refetch={refetch} />
                        : <TableSortingCreator
                            isLoadingTable={isLoadingTable}
                            Component={BalancesTableDumb}
                            rows={tableRows}
                        />
                }
            </OverlayUnTouchable>
        </PageLayout>
    )
}

export default BalancesPage
